import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import {
  Str_AlreadyUsed,
  Str_ChangeFail,
  Str_ChangeSuc,
  Str_CodeAlreadySend,
  Str_CodeNotNull,
  Str_CodeSendFail,
  Str_Confirm,
  Str_Email,
  Str_EmailFormatErr,
  Str_EmailNotNull,
  Str_Err1015,
  Str_InputCode,
  Str_InputEmail,
  Str_InputTelno,
  Str_NoSpacesAllowed,
  Str_Phone,
  Str_PhoneFormatErr,
  Str_PhoneNotNull,
  Str_ReSend,
  Str_SendCode,
  Str_SetEmail,
  Str_SetTelno,
  Str_UpdateEmail,
  Str_UpdateTelno,
} from "../../language/string_res";
import { Keyboard, Pressable, StyleSheet, Text, View } from "react-native";
import {
  color_333333,
  color_EEF2F9,
  color_main,
  white,
  ColorF5F5F5,
} from "../../assets/style/colors";
import React, { useEffect, useRef, useState } from "react";
import { CommonInput } from "../login/CommonInput";
import { showToast } from "../../components/Toast";
import {
  changeEmail,
  changePhone,
  checkAcApi,
  checkVerifyCode,
  sendVerifyCode,
} from "../../net/service";
import { getLanguage } from "../../language/i18n";
import { isNumeric, isValidEmail } from "../login/register";
import { MainNavProps } from "../navigation/main/MainParamList";
import { hideLoading, showLoading } from "../../components/Loading";
import { getUid, getVcode } from "../../store/token";
import { countryCodeManager } from "../CountryCodeSelete";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { BehavioralVerifyModal } from "../login/BehavioralVerifyModal";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";

export const BindPhoneOrEmail = ({
  navigation,
  route,
}: MainNavProps<"BindPhoneOrEmail">) => {
  const type = route.params.type;
  const defValue = route.params.defValue;
  const [phoneOrEmail, setPhoneOrEmail] = useState("");
  const [code, setCode] = useState("");
  const language = getLanguage();
  const [countryCode, setCountryCode] = useState("+86");
  const uid = getUid();
  // const [remainTime, setRemainTime] = useState(0);
  const [sendText, setSendText] = useState(Str_SendCode);
  const [running, setRunning] = useState(false);
  let timer: any;
  let endTime: number = 0;
  const eventTagRef = useRef("");
  const [isVerifyModalShow, setIsVerifyModalShow] = useState(false);
  const captchaToken = useRef<string>("");

  useEffect(() => {
    countryCodeManager.setListener(setCountryCode);
    if (!countryCode) {
      const code = getLanguage();
      let countryCode = "+86";
      if (code === "es") {
        countryCode = "+34";
      } else if (code === "ja") {
        countryCode = "+81";
      } else if (code === "vi") {
        countryCode = "+84";
      } else if (code === "pt") {
        countryCode = "+351";
      } else if (code === "en") {
        countryCode = "+1";
      }
      setCountryCode(countryCode);
    }
  }, []);

  function startTime() {
    endTime = Date.now() + 60 * 1000;
    setRunning(true);
    updateRemain();
  }
  function updateRemain() {
    cancelAnimationFrame(timer);
    const tick = () => {
      const left = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      // setRemainTime(left);
      setSendText(`${left}s`);
      if (left > 0) {
        timer = requestAnimationFrame(tick);
      } else {
        reset();
      }
    };

    tick();
  }
  function reset() {
    cancelAnimationFrame(timer);
    // setRemainTime(0);
    setSendText(Str_ReSend);
    setRunning(false);
  }

  function sendCode() {
    if (running) return;
    if (!phoneOrEmail || phoneOrEmail.trim().length <= 0) {
      showToast(type === "phone" ? Str_PhoneNotNull : Str_EmailNotNull);
      return;
    }
    if (type === "phone") {
      if (!isNumeric(phoneOrEmail.trim())) {
        showToast(Str_PhoneFormatErr);
        return;
      }
    } else {
      if (!isValidEmail(phoneOrEmail.trim())) {
        showToast(Str_EmailFormatErr);
        return;
      }
    }

    setIsVerifyModalShow(true);
  }

  const onSendCodeBehavioralVerifySuccess = async (
    isSuccess: boolean,
    token: string
  ) => {
    // 验证未通过
    if (isSuccess !== true) {
      return;
    }

    // 记录验证码token
    captchaToken.current = token;
    // 检查账号并且发送验证码
    checkAccountAndSendCode(phoneOrEmail, !defValue ? "14" : "16");
  };

  // 检查账号并且发送验证码
  function checkAccountAndSendCode(acc: string, send_type: string) {
    const vcode = getVcode();
    // 先校验账号,获取EventTag
    checkAcApi({ account: acc, vcode: vcode, lang: language })
      .then((res) => {
        if (res.code !== 0) {
          showToast(res.msg ?? "");
          reset();
          return;
        }
        if (res.data && res.data.exist === true) {
          showToast(
            res.msg ||
              (type === "phone" ? Str_Phone : Str_Email) + Str_AlreadyUsed
          );
          reset();
          return;
        }

        // 存在
        const eventTag = res.data.eventTag;
        eventTagRef.current = eventTag;
        startTime();
        // 发送手机验证码
        sendVerifyCode({
          send_type: send_type,
          eventTag: eventTag,
          lang: language,
          vcode: vcode,
          captchaToken: captchaToken.current,
        }).then((res) => {
          if (res.code === 0) {
            showToast(Str_CodeAlreadySend);
          } else {
            showToast(res.msg || Str_CodeSendFail);
            reset();
          }
        });
      })
      .catch((res) => {
        showToast(res.msg || Str_CodeSendFail);
        reset();
      });
  }

  /**
   * 验证手机验证码
   */
  function verifyCodeByPhone() {
    const type = !defValue ? "14" : "16";
    const body = {
      vcode: getVcode(),
      send_type: type,
      code: code,
      lang: language,
      eventTag: eventTagRef.current,
    };
    checkVerifyCode(body).then((r) => {
      if (r.code !== 0 || !r.data) {
        showToast(r.msg ?? Str_Err1015);
        hideLoading();
        return;
      }
      const token = r.data.otp_token;
      changePhone(`${countryCode}-${phoneOrEmail}`, token)
        .then((r1) => {
          if (r1.code !== 0) {
            showToast(r1.msg ?? Str_ChangeFail);
            return;
          }
          // showToast(Str_ChangeSuc)
          AsyncStorage.setItem(`${uid}-LoginGuide`, "");
          navigation.goBack();
        })
        .finally(() => {
          hideLoading();
        });
    });
  }
  /**
   * 验证邮箱验证码
   */
  function verifyCodeByEmail() {
    const type = !defValue ? "14" : "16";
    const body = {
      vcode: getVcode(),
      send_type: type,
      code: code,
      lang: language,
      eventTag: eventTagRef.current,
    };
    checkVerifyCode(body).then((r) => {
      if (r.code !== 0 || !r.data) {
        showToast(r.msg ?? Str_Err1015);
        hideLoading();
        return;
      }
      const token = r.data.otp_token;
      changeEmail(phoneOrEmail, token)
        .then((r1) => {
          if (r1.code !== 0) {
            showToast(r1.msg ?? Str_ChangeFail);
            return;
          }
          // showToast(Str_ChangeSuc)
          AsyncStorage.setItem(`${uid}-LoginGuide`, "");
          navigation.goBack();
        })
        .finally(() => {
          hideLoading();
        });
    });
  }
  const handleSave = async () => {
    if (phoneOrEmail.trim().length <= 0) {
      showToast(type === "phone" ? Str_PhoneNotNull : Str_EmailNotNull);
      return;
    }
    if (type === "phone") {
      if (!isNumeric(phoneOrEmail.trim())) {
        showToast(Str_PhoneFormatErr);
        return;
      }
    } else {
      if (!isValidEmail(phoneOrEmail.trim())) {
        showToast(Str_EmailFormatErr);
        return;
      }
    }
    if (code.trim().length <= 0) {
      showToast(Str_CodeNotNull);
      return;
    }
    showLoading("");
    if (type === "phone") {
      verifyCodeByPhone();
    } else {
      verifyCodeByEmail();
    }
  };

  return (
    <ScreenCloseModal
      title={
        type === "phone"
          ? !defValue
            ? Str_SetTelno
            : Str_UpdateTelno
          : !defValue
          ? Str_SetEmail
          : Str_UpdateEmail
      }
    >
      <Pressable
        onPress={Keyboard.dismiss}
        style={{ flex: 1, paddingHorizontal: 24 }}
      >
        <View
          style={{
            backgroundColor: white,
            borderRadius: 16,
            paddingVertical: 40,
            paddingHorizontal: 20,
            marginTop: 24,
            minHeight: 400,
          }}
        >
          <CommonInput
            style={{ marginHorizontal: 0 }}
            placeholder={type === "phone" ? Str_InputTelno : Str_InputEmail}
            source={
              type === "phone"
                ? require("../../assets/image/icon_phone.png")
                : require("../../assets/image/icon_email.png")
            }
            text={phoneOrEmail}
            showClean={true}
            autoFocus={true}
            keyboardType={type === "phone" ? "numeric" : undefined}
            sendText={type === "phone" ? countryCode : undefined}
            sendCode={() => {
              type === "phone" && navigation.navigate("MainCountryCodeSelete");
            }}
            onChangeText={(text) => {
              const cleaned = text.replace(/[ 　]+/g, "");
              if (cleaned !== text) {
                showToast(Str_NoSpacesAllowed);
              }
              setPhoneOrEmail(cleaned);
            }}
          />

          <CommonInput
            style={{ marginHorizontal: 0, marginTop: 20 }}
            placeholder={Str_InputCode}
            source={require("../../assets/image/icon_psd.png")}
            text={code}
            sendText={sendText}
            sendCode={sendCode}
            onChangeText={setCode}
          />

          <View style={{ marginTop: 60, alignItems: "center" }}>
            <Pressable
              onPress={handleSave}
              style={{
                backgroundColor: color_main,
                borderRadius: 12,
                paddingVertical: 16,
                paddingHorizontal: 60,
                minWidth: 200,
                maxWidth: 300,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  color: white,
                  fontSize: 16,
                  fontWeight: "600",
                }}
              >
                {Str_Confirm}
              </Text>
            </Pressable>
          </View>
        </View>
       
      </Pressable>

      <BehavioralVerifyModal
        visible={isVerifyModalShow}
        onResult={(isSuccess, token) => {
          setIsVerifyModalShow(false);
          onSendCodeBehavioralVerifySuccess(isSuccess, token);
        }}
      />
    </ScreenCloseModal>
  );
};

const styles = StyleSheet.create({
  inputBg: {
    flexDirection: "row",
    backgroundColor: color_EEF2F9,
    borderRadius: 5,
    alignItems: "center",
    height: 46,
    marginHorizontal: 16,
    paddingHorizontal: 16,
  },
  input: { height: 40, flex: 1, color: color_333333 },
});
